import React from 'react';
import { Box, Button, SxProps, Typography } from '@mui/material';
import { warning } from '_lex/_foundations/phxColors';
import { translate as t } from 'hooks/useTranslations';

export type DisabledPolicyAlertProps = {
  policyTitle: string;
  policyNumber: string;
  onAccept?: () => void;
  onReject?: () => void;
  containerClass?: SxProps;
  isLoading?: boolean;
  disable?: boolean;
};

const DisabledPolicyAlert = React.memo(
  ({ policyTitle, policyNumber, onAccept, onReject, containerClass, isLoading, disable }: DisabledPolicyAlertProps) => {
    const handleAccept = () => {
      console.log('Accept disabled policy:', policyNumber, policyTitle);
      if (onAccept) onAccept();
    };

    const handleReject = () => {
      console.log('Reject disabled policy:', policyNumber, policyTitle);
      if (onReject) onReject();
    };

    return (
      <Box
        sx={{
          ...containerClass,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: 60,
          px: 8,
          border: `solid 1px ${warning[200]}`,
          boxShadow: '0 8px 12px rgba(0,0,0,0.1)',
          backgroundColor: warning[100],
        }}
      >
        <Box>
          <Typography
            variant='body1'
            fontWeight='medium'
          >
            {t('draftManuals.policy.disabledPolicy.title')}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant='outlined'
            color='error'
            size='small'
            disabled={isLoading || disable}
            onClick={handleReject}
          >
            {t('draftManuals.policy.disabledPolicy.reject')}
          </Button>
          <Button
            variant='contained'
            color='primary'
            size='small'
            disabled={isLoading || disable}
            onClick={handleAccept}
          >
            {t('draftManuals.policy.disabledPolicy.accept')}
          </Button>
        </Box>
      </Box>
    );
  }
);

export default DisabledPolicyAlert;
